module.exports = __webpack_public_path__ + "img/ci_filter_off.b70a0102.svg";